import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import usePaginatedFilter from "../../hooks/usePaginatedFilters";
import PaginationControls from "../../utils/PaginationControls";
import Loading from "../../utils/loading";
import { BASE_URL } from "../../utils/config"; 
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import profile from "../../assets/imgs/passport.png";
import Typography from "@mui/material/Typography";
import { Autocomplete, TextField, Stack, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {compressImage} from "../../utils/compressImage";
import {resizeImage} from "../../utils/resizeImage";
import Paper from "@mui/material/Paper";
import { Doughnut } from "react-chartjs-2";
import Modal from "@mui/material/Modal";
import { Chart, ArcElement } from "chart.js";
import Toast from "../../utils/Toast";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useVendor } from "../../context/VendorSignupContext";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useUser } from "../../context/UserContext";
import moment from "moment";
import Toaster from "../../utils/toaster";
import ButtonLoader from "../../utils/buttonLoader";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

Chart.register(ArcElement);

const top100Films = [
  { title: "Beauty" },
  { title: "Phones" },
  { title: "Gadgets" },
  { title: "Electronics", year: 2008 },
  { title: "Makeup", year: 1957 },
  { title: "Cough", year: 1993 },
  { title: " Summer", year: 1994 },
  { title: "Clothing", year: 2001 },
  { title: "Ceramics", year: 1971 },
  { title: "Footwear", year: 2007 },
  { title: "Foodstuff", year: 1976 },
  { title: "Toys", year: 1962 },
  { title: "Children", year: 1944 },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const columns = [
  // { id: "product_image", label: "Image" },
  { id: "name", label: "Product" },
  { id: "type", label: "Type" },
  { id: "category", label: "Category" },
  { id: "brand", label: "Brand" },
  { id: "cost_price", label: "Cost " },
  { id: "selling_price", label: "Selling " },
  { id: "created_at,", label: "Published" },
  { id: "status", label: "Status" },
  { id: "edit", label: "Edit" },
  { id: "delete", label: "Delete" },
];

const categoryColumns = [
  // { id: "category_image", label: "Category Image" },
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "sub_categories", label: "Sub Categories" },
  // { id: "created_at,", label: "Created At" },
  { id: "edit", label: "Edit" },
  { id: "delete", label: "Delete" },
];

const brandColumns = [
  // { id: "brand_image", label: "Brand Image" },
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  // { id: "created_at,", label: "Created At" },
  { id: "edit", label: "Edit" },
  { id: "delete", label: "Delete" },
];

const data = {
  datasets: [
    {
      data: [83, 20],

      backgroundColor: ["rgba(236, 112, 122, 1)", "rgba(16, 172, 126, 1)"],
    },
  ],
};

var config = {
  cutout: 28,
  responsive: true,
  maintainAspectRatio: true,
  options: {},
};

function createData(
  product_image,
  name,
  type,
  brand,
  selling_price,
  created_at,
  status,
  action
) {
  return {
    product_image,
    name,
    type,
    brand,
    selling_price,
    created_at,
    status,
    action,
  };
}



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ProductList = () => {
  const [products, setProducts] = useState();
  const [brands, setBrand] = useState();
  const [categories, setCategories] = useState();
  const [subCategories, setSubCategories] = useState([]);
  const [newProduct, setNewProduct] = useState();
  const [value, setValue] = useState(0);
  const [toast, setToast] = useState(null);
  const [moreImages, setMoreImages] = useState([]);
  const { user } = useUser();
  const {inputValues, setState, onChangeHandler,loading, setLoading,  visible,
    setVisible,} = useVendor();
  const [toastType, setToastType] = useState("");
  const [rejectionMeta, setRejectionMeta] = useState({
    productId: null,
    status: null,
  });


  const PRODUCT_STATUSES = [
    { label: "Published", value: "1" },
    { label: "Pending", value: "0" },
    { label: "Rejected", value: "2" },
    { label: "Awaiting Approval", value: "3" },
  ];

  const pagination = usePaginatedFilter({
    data: products,
    searchKey: ["name", "cost"],
    statusKey: "status",
    statusOptions: PRODUCT_STATUSES,
  });

  const {  paginatedData, currentPage, totalPages, pageSize, searchTerm, statusFilter, setCurrentPage, setPageSize, setSearchTerm, setStatusFilter } = pagination;


  const [toastMsg, setToastMsg] = useState("");
  const [newProductModal, setNewProductModal] = useState(false);
  const  [newCategoryModal, setNewCategoryModal] = useState(false);
  const  [publishedCount, setPublishedCount] = useState(0);
  const  [newRejectedProductModal, setNewRejectedProductModal] = useState(false);
  const  [newSubCategoryModal, setNewSubCategoryModal] = useState(false);
  const  [newBrandModal, setNewBrandModal] = useState(false);
  const [rejectedProducts, setRejectedProduct] = useState([]);
  const  [editProductModal, setEditProductModal] = useState(false);
  const  [editCategoryModal, setEditCategoryModal] = useState(false);
  const  [editSubCategoryModal, setEditSubCategoryModal] = useState(false);
  const  [editBrandModal, setEditBrandModal] = useState(false);
  const [productLiveState, setProductLiveState] = useState("");
  const handleModalClose = () => setNewProductModal(false);
  const handleCategoryModalClose = () => setNewCategoryModal(false);
  const handleRejectedProductModalClose = () => setNewRejectedProductModal(false);
  const handleSubCategoryModalClose = () => setNewSubCategoryModal(false);
  const handleBrandModalClose = () => setNewBrandModal(false);
  const handleEditProductModalClose = () => setEditProductModal(false);
  const handleEditCategoryModalClose = () => setEditCategoryModal(false);
  const handleEditSubCategoryModalClose = () => setEditSubCategoryModal(false);
  const handleEditBrandModalClose = () => setEditBrandModal(false);
  const [selectedProduct, setSelectedProduct] = useState(null); 
const [isEditMode, setIsEditMode] = useState(false);
  const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [selectedCategory, setSelectedCategory] = useState("");


  const handleChange = (event, newValue) => {
    setState((inputValues) => ({
      ...inputValues,
      tags: newValue,
    }));
  };    
  


  const handleCategoryChange = (e) => {
      const newCategory = e.target.value;
      setSelectedCategory(newCategory);
      const matchingSubCategories = categories.find((category) => category.id == newCategory) || [];
      setSubCategories(matchingSubCategories?.sub_categories);
      if(!e?.persist){
          setState(inputValues, ({...inputValues, [e?.target.name]: e?.target.value })); 
      }else {
          e?.persist();
          const target = e?.target;
    if (target?.name) {
      setState((inputValues) => ({
        ...inputValues,
        [target.name]: target.value,
      }));
    }
      }
  };

  


  const VendorCreateProduct = async(e) => {
    if (e) {
      e.preventDefault(); 
      setLoading(true)
      inputValues.more_images = moreImages?.join(", ")
      console.log(inputValues)
    try {
      const response = await fetch(
        !isEditMode ? `${BASE_URL}/products/create` :
        `${BASE_URL}/products/update/${selectedProduct.id}`, 
        {
        method: 'POST',
        headers:{ 
          'Content-Type': 'application/json;charset=UTF-8', 
          "Accept": "application/json" ,
          'Authorization': `Bearer ${user?.token}`
        },
          body:JSON.stringify(inputValues)
      });
      if (response.ok) {
        const data = await response.json();
        setToastMsg("Great! Product added successfully");
        setToastType("success")
        setInterval(() => {
          setToastMsg("");
 }, 5000);
        setLoading(false)
        setNewProduct(data)
        handleModalClose()
      } else {
        const error = await response.text();
        console.error('Error posting product:', error);
        setLoading(false)
        setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
        setToastType("error")
        setInterval(() => {
          setToastMsg("");
 }, 3000);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  }
  };

  const vendorUpdateProduct = async(e) => {
    if (e) {
      e.preventDefault(); 
    try {
      const response = await fetch(
        `${BASE_URL}/products/update/1`, {
        method: 'POST',
        headers:{ 
          'Content-Type': 'application/json;charset=UTF-8', 
          "Accept": "application/json" ,
          'Authorization': `Bearer ${user?.token}`
        },
          body:JSON.stringify(inputValues)
      });
      if (response.ok) {
        const data = await response.json();
        setNewProduct(data)
        handleEditProductModalClose()
        setToastMsg("Great! Product updated successfully");
        setToastType("success")
        setInterval(() => {
          setToastMsg("");
 }, 5000);
      } else {
        const error = await response.text();
        setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
        setToastType("error")
        setInterval(() => {
          setToastMsg("");
 }, 3000);
      }
    } catch (error) {
      setToastMsg(error);
        setToastType("error")
        setInterval(() => {
          setToastMsg("");
 }, 5000);
    }
  }
  };


  const [formData, setFormData] = useState({
    rejectedReason: ""
  });

const onChangeHandlerForReason = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
};


const handleProductLiveStatus = async (product, e) => {
  const selectedStatus = e?.target?.value;
  setLoading(true);

  // Handle rejection separately
  if (selectedStatus === "2") {
    setRejectionMeta({
      productId: product.id,
      status: selectedStatus,
    });
    setNewRejectedProductModal(true);
    setLoading(false);
    return;
  }

  const requestBody = {
    product_id: product.id,
    status: selectedStatus,
  };

  const endPointToUse =
    selectedStatus === "1"
      ? "products/update-status/admin"
      : selectedStatus === "3"
      ? "products/sendforapproval"
      : "";

  const verb =
    selectedStatus === "1"
      ? "POST"
      : selectedStatus === "3"
      ? "PUT"
      : "";

  try {
    const response = await fetch(`${BASE_URL}/${endPointToUse}`, {
      method: verb,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + user?.token,
      },
      body: JSON.stringify(requestBody),
    });

    const result = await response.json();

    if (result.status) {
      setToast({ message: `Successful!... ${result.message}`, type: "success" });
      getProducts();
    } else {
      setToast({ message: `Failed!... ${result.message}`, type: "error" });
      setProductLiveState("");
    }
  } catch (error) {
    setToast({ message: `Failed... ${error}`, type: "error" });
    setProductLiveState("");
  } finally {
    setLoading(false);
    setTimeout(() => setToast(null), 5000);
  }
};




  const addReasonForProductReject = async () => {
    setLoading(true);
  
    try {
      const response = await fetch(`${BASE_URL}/products/decline-product`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user?.token,
        },
        body: JSON.stringify({
          product_id: rejectionMeta.productId,
        status: rejectionMeta.status,
          reason: formData.rejectedReason,
        }),
      });
  
      const result = await response.json();
  
      if (!response.ok) {
        setToast({ message: "Failed to Submit!", type: "error" });
        return;
      }
  
      setToast({ message: result.message, type: "success" });
      handleRejectedProductModalClose();
      getProducts();
  
      setFormData({ rejectedReason: "" });
    } catch (error) {
      setToast({ message: "Failed to submit!", type: "error" });
    } finally {
      setLoading(false);
      setTimeout(() => setToast(null), 7000);
    }
  };
  



  const vendorUpdateCategory = async(e) => {
    if (e) {
      e.preventDefault(); 
    try {
      const response = await fetch(
        `${BASE_URL}/product-category/update?category_id=${inputValues.id}&category_image=${inputValues.category_image}&name=${inputValues.name}&description=${inputValues.description}`, {
        method: 'POST',
        headers:{ 
          'Content-Type': 'application/json;charset=UTF-8', 
          "Accept": "application/json" ,
          'Authorization': `Bearer ${user?.token}`
        },
      });
      console.log(inputValues)
      if (response.status) {
        const data = await response.json();
        console.log('product:', data);
        setNewProduct(data)
        handleEditCategoryModalClose()
        setToastMsg("Great! Category updated successfully");
        setToastType("success")
        setInterval(() => {
          setToastMsg("");
 }, 5000);
      } else {
        const error = await response.text();
        console.error('Error posting product:', error);
        setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
        setToastType("error")
        setInterval(() => {
          setToastMsg("");
 }, 3000);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  }
  };

  
  const vendorUpdateSubCategory = async(e) => {
    if (e) {
      e.preventDefault(); 
    try {
      const response = await fetch(
        `${BASE_URL}/product-sub-category/update?category_id=${inputValues.id}&category_image=${inputValues.category_image}&name=${inputValues.name}&description=${inputValues.description}`,
        {
        method: 'POST',
        headers:{ 
          'Content-Type': 'application/json;charset=UTF-8', 
          "Accept": "application/json" ,
          'Authorization': `Bearer ${user?.token}`
        },
      });
      console.log(inputValues)
      if (response.ok) {
        const data = await response.json();
        console.log('product:', data);
        setNewProduct(data)
        handleEditSubCategoryModalClose()
        setToastMsg("Great! Product added successfully");
        setToastType("success")
        setInterval(() => {
          setToastMsg("");
 }, 5000);
      } else {
        const error = await response.text();
        console.error('Error posting product:', error);
        setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
        setToastType("error")
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  }
  };

  const vendorUpdateBrand = async(e) => {
    if (e) {
      e.preventDefault(); 
    try {
      const response = await fetch(
        `${BASE_URL}/product-brand/update?brand_id=${inputValues.id}&brand_image=${inputValues.brand_image}&name=${inputValues.name}&description=${inputValues.description}`, {
        method: 'POST',
        headers:{ 
          'Content-Type': 'application/json;charset=UTF-8', 
          "Accept": "application/json" ,
          'Authorization': `Bearer ${user?.token}`
        },
      });
      console.log(inputValues)
      if (response.ok) {
        const data = await response.json();
        console.log('product:', data);
        setNewProduct(data)
        handleEditBrandModalClose()
        setToastMsg("Great! Brand updated successfully");
        setToastType("success")
        setInterval(() => {
          setToastMsg("");
 }, 5000);
      } else {
        const error = await response.text();
        console.error('Error posting product:', error);
        setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
        setToastType("error")
        setInterval(() => {
          setToastMsg("");
 }, 3000);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
  }
  };


 function editProduct(data){
    setEditProductModal(true)
    console.log(data)
    setState(data)
  }

 function editCategory(data){
  setEditCategoryModal(true)
  console.log(data)
  setState(data)
 }

 function editSubCategory(data){
  setEditSubCategoryModal(true)
  console.log(data)
  setState(data)
 }

 function editBrand(data){
  setEditBrandModal(true)
  console.log(data)
  setState(data)
 }


  // let publishedCount = 0;

  const id = "PMS-892040"


 
  
  const getProducts = () => {
    setLoading(true);
    let url = `${BASE_URL}/products`;
  
    if (user?.accountType === "Admin") {
      url = `${BASE_URL}/products/get-all`;
    } else if (user?.accountType !== "Vendor") {
      url = `${BASE_URL}/products/?store_id=${id}`;
    }
  
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        const products = result?.data || [];
  
        setProducts(products);
  
        // Count published products (status === 1)
        const publishedProducts = products.filter(
          (item) => Number(item.status) === 1
        );
  
        setPublishedCount(publishedProducts?.length);
  
        if (user?.accountType === "Vendor") {
          getAllRejectedProducts();
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  

  const getAllRejectedProducts = () => {
    try {
      fetch(`${BASE_URL}/products/all-decline-product`, {
        method: 'GET',
        headers:{ 
          'Content-Type': 'application/json;charset=UTF-8', 
          "Accept": "application/json" ,
          'Authorization': `Bearer ${user?.token}`
        },
      })
     
      .then((resp) => resp.json())
      .then((result) => {
        console.log(result)
        if(result?.status){
          setRejectedProduct(result?.data)
        }else{
          setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
          setToastType("error")
          setInterval(() => {
            setToastMsg("");
   }, 3000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
     
    } catch (error) {
      console.error('Network error:', error);
    }
  }
 
  const addCategory = (e) => {
    e.preventDefault()
    fetch(
      `${BASE_URL}/product-category/create?category_image=${inputValues.category_image}&name=${inputValues.name}&description=${inputValues.description}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        if(result.status){
          setToastMsg("Great! Category added successfully");
          setToastType("success")
          setInterval(() => {
            setToastMsg("");
   }, 5000);
        console.log(result);
        setNewProduct(result)
        handleCategoryModalClose()
        }else{
          setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
          setToastType("error")
          setInterval(() => {
            setToastMsg("");
   }, 3000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addSubCategory = (e) => {
    e.preventDefault()
    fetch(`${BASE_URL}/product-sub-category/create?category_id=${inputValues.category_id}&name=${inputValues.name}&description=${inputValues.description}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        console.log(result);
        if(result.status){
          setToastMsg("Great! Subcategory added successfully");
          setToastType("success")
          setInterval(() => {
            setToastMsg("");
   }, 5000);
        console.log(result);
        setNewProduct(result)
        handleSubCategoryModalClose()
        }else{
          setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
          setToastType("error")
          setInterval(() => {
            setToastMsg("");
   }, 3000);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addBrand = (e) => {
    e.preventDefault()
    fetch(
      `${BASE_URL}/product-brand/create?brand_image=${inputValues.brand_image}&name=${inputValues.name}&description=${inputValues.description}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        if(result.status){
          setToastMsg("Great! Brand added successfully");
          setToastType("success")
          setInterval(() => {
            setToastMsg("");
   }, 5000);
          console.log(result);
          setNewProduct(result)
          handleBrandModalClose()
        }else{
          setToastMsg("Oops! there seems to be an error. Fill in correct credentials")
          setToastType("error")
          setInterval(() => {
            setToastMsg("");
   }, 3000);
        }
        
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCategories = () => {
    fetch(`${BASE_URL}/product-category/get-all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        console.log(result);
        setCategories(result.data.categories)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  
  const getBrands = () => {
    fetch(`${BASE_URL}/product-brand/get-all?store_id=${id}`,{
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("authToken"),
      },
    })
      .then((resp) => resp.json())
      .then((result) => {
        console.log(result);
        setBrand(result.data.brands)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteProduct = (productId) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this item?');
    if (isConfirmed) {
      fetch(`${BASE_URL}/products/delete-account?product_id=${productId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      })
        .then((resp) => resp.json())
        .then((result) => {
          if(result.status){
            setToastMsg("Great! Product deleted successfully");
            setToastType("success")
            setInterval(() => {
              setToastMsg("");
     }, 5000);
            console.log(result);
            setNewProduct(result)
          }else{
            setToastMsg("Oops! there seems to be an error. Try again")
            setToastType("error")
            setInterval(() => {
              setToastMsg("");
     }, 3000);
      }
        })
      .catch((err) => {
        console.log(err);
      });
    }
  };

  const deleteCategory = (categoryId) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this category?');
    if (isConfirmed) {
      fetch(`${BASE_URL}/product-category/delete?category_id=${categoryId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      })
        .then((resp) => resp.json())
        .then((result) => {
          if(result.status){
            setToastMsg("Great! Category deleted successfully");
            setToastType("success")
            setInterval(() => {
              setToastMsg("");
     }, 5000);
            console.log(result);
            setNewProduct(result)
            setInterval(() => {
              setToastMsg("");
     }, 3000);
          }else{
            setToastMsg("Oops! there seems to be an error. Try again")
            setToastType("error")
            setInterval(() => {
              setToastMsg("");
     }, 3000);
          }
          
        })
      .catch((err) => {
        console.log(err);
      });
    }
  };
  const deleteSubCategory = (categoryId) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this category?');
    if (isConfirmed) {
      fetch(`${BASE_URL}/product-sub-category/delete?sub_category_id=${categoryId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      })
        .then((resp) => resp.json())
        .then((result) => {
          if(result.status){
            setToastMsg("Great! Subcategory deleted successfully");
            setToastType("success")
            setInterval(() => {
              setToastMsg("");
     }, 5000);
            console.log(result);
            setNewProduct(result)
          }else{
            setToastMsg("Oops! there seems to be an error. Try again")
            setToastType("error")
            setInterval(() => {
              setToastMsg("");
     }, 3000);
          }
        })
      .catch((err) => {
        console.log(err);
      });
    }
  };


  const deleteBrand = (brandId) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this brand?');
    if (isConfirmed) {
      fetch(`${BASE_URL}/product-brand/delete?brand_id=${brandId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      })
        .then((resp) => resp.json())
        .then((result) => {
          if(result.status){
            setToastMsg("Great! Brand deleted successfully");
            setToastType("success")
            setInterval(() => {
              setToastMsg("");
     }, 5000);
            console.log(result);
            setNewProduct(result)
          }else{
            setToastMsg("Oops! there seems to be an error. Try again")
            setToastType("error")
            setInterval(() => {
              setToastMsg("");
     }, 3000);
          }
        })
      .catch((err) => {
        console.log(err);
      });
    }
  };

  const addCommasToNumberString = (numberString) =>{
    return  numberString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
  }

  
  useEffect(() => {
    getProducts();
    getBrands()
    getCategories()
    // setCurrentPage(1);
console.log(user?.accountType)
  }, [newProduct, searchTerm, statusFilter, pageSize]);

  const [bestTaken, setBestTaken] = useState([
    { name: 'Before meal', value: true },
    { name: 'With meal', value: false },
    { name: 'After meal', value: false },
    { name: 'Morning', value: false },
    { name: 'Afternoon', value: false },
    { name: 'Night', value: false }
]);

  const [notFor, setItems] = useState([
    { name: 'Pregnant women', value: false },
    { name: 'Breastfeeding mothers', value: false },
    { name: 'Kids under 4', value: false },
    { name: 'Kids under 8', value: true },
    { name: 'Kids under 12', value: false },
  ]);

    const handleBestTakenToggle = (index) => {
      bestTaken[index].value = !bestTaken[index].value; 
      setBestTaken([...bestTaken]); 
      console.log(bestTaken)
  }

    const handleNotForToggle = (index) => {
        notFor[index].value = !notFor[index].value; 
        setItems([...notFor]); //
        console.log(notFor)
    }
    const showSidebar = () => {
      setVisible(true)
    }
    const hideSidebar = () => {
      setVisible(false)
    }
  return (
    <section>
      <Loading loading={loading} />
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
      {/* <Toaster text={toastMsg} className={toastType} /> */}
      <section className="page__header">
        <div className="flex-container alc">
          <ShoppingCartIcon />
          <h3>Manage Products</h3>
        </div>
        {visible ?
         <div onClick={hideSidebar} className="no-large-display pointer">
          <CloseIcon />
        </div > :  
        <div onClick={showSidebar}  className="no-large-display pointer">
          <MenuIcon />
        </div>
        }
      </section>
      <div className="s-divider"></div>
      <section style={{ display: "flex" }}>
        <div className="stat m-10">
          <div className="left__stat py-32">
            <div>
              <Doughnut data={data} options={config} className="w80" />
            </div>
            <h3 className="stat__value ml-10">
              {products?.length}
              {user?.accountType !== "Admin" && (
              <p className="sub__title">Total Products</p>
              )}
              {user?.accountType === "Admin" && (
              <p className="sub__title">Awaiting Approval</p> 
              )}
            </h3>
          </div>
          <div className="right__stat">
            <div className="right__sub s-divider">
              <h3 className="stat__value c-success">{publishedCount}</h3>
              <p className="sub__title">Published</p>
            </div>
            <div className="right__sub">
              <h3 className="stat__value c-error">{rejectedProducts?.length}</h3>
              <p className="sub__title">Rejected</p>
            </div>
          </div>
        </div>
      </section>
      {/* Categories, subcategories and brand tab */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="basic tabs example">
                  <Tab label="Products List" {...a11yProps(0)} />
                    <Tab label="Categories" {...a11yProps(1)} />
                    <Tab label="Sub Categories" {...a11yProps(2)} />
                    <Tab label="Brands" {...a11yProps(3)} />
                    <Tab label="Rejected List" {...a11yProps(4)} />
            </Tabs>
      </Box>
      {/* End categories, subcategories and brand tab */}
      <TabPanel value={value} index={0}>
        <section className="flex-container alc p-y my-40">



{/* Starts Here */}
          <div className="">
        <PaginationControls {...pagination} />
{/* Ends Here */}

          </div>
          <div className="">
            <button
              className="btn btn-primary p-25"
              onClick={() => setNewProductModal(true)}>
              Add product
            </button>
          </div>
        </section>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="Product Table">
            <TableHead>
              <TableRow>
                {columns?.map((column) => (
                  <TableCell>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData?.map((product, index) => (                   
                <TableRow key={product?.id} className="capitalize">
                  {/* <TableCell className="b-r" onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <div className="d-flex alc f-10 flex-start">
                        <img src={product.image} alt="" className="w50" alt={product?.name}/>
                    </div>
                  </TableCell> */}
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <div className="lheight13">
                      <p className="">{product?.name} </p>
                    </div>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <div className="lheight13">
                      <p className="">{product?.product_type} </p>
                    </div>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <p className="">{categories?.map(category =>(
                    category?.id == product?.category_id && category?.name 
                  ))}        </p>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                  <p className="">{brands?.map(brand =>(
                      brand?.id == product?.brand_id && brand?.name 
                    ))} </p>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}> 
                  <p className=""> &#x20A6;{addCommasToNumberString(product?.cost_price)}  </p>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}> <p className=""> &#x20A6;{addCommasToNumberString(product?.selling_price)} </p> </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}> <p className=""> {moment(product?.created_at).add(1, "years").calendar()} </p></TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    {" "}
                    {/* 0 = Pending/No Action    1 = Accept/Publish   2 = Decline/Reject    3 = Send For Approval */}
                    {product?.status === '0' ?
                    <span className="badge warning c-chalk">Pending</span>
                    : product?.status === '1' ? <span className="badge success c-chalk">Published</span> :
                    product?.status === '2' ? <span className="badge error c-chalk">Rejected</span> :
                    <span className="badge awaiting__approval c-chalk">Awaiting  Approval</span>
                    }
                  </TableCell>
                  <TableCell  
                  onClick={() => {
                    console.log(product);
                                    setSelectedProduct(product); 
                                    setIsEditMode(true);
                                    setNewProductModal(true);
                                  }}
>
                    {" "}
                    <EditIcon />{" "}
                  </TableCell>
                  <TableCell onClick={()=>deleteProduct(product.id)}>
                    {" "}
                    <DeleteIcon/>{" "}
                  </TableCell>
                  <TableCell onClick={() => console.log(product.id)}>
                  <select
                      name="update__order"
                      className="last-name form-control"
                      value={productLiveState}
                      onChange={(e) => handleProductLiveStatus(product, e)}
                      style={{marginTop: 18, textTransform: 'capitalize', width: '60%', height: 37,
                      padding: 10}}>
                    <option value="">Manage Order</option>
                    {user.accountType === "Admin" && (
                      <>
                       <option value="2">Reject</option>
                       <option value="1">Approve/Publish</option>
                       </>
                    )}
                    {user.accountType === "Vendor" && (
                      <option value="3">Send for Approval</option>
                    )}
                </select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TabPanel>


      {/* Product Rejected List */}
      <TabPanel value={value} index={4}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="Product Table">
            <TableHead>
              <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Cost </TableCell>
                  <TableCell>Selling</TableCell>
                  <TableCell>Reason</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Edit</TableCell>
                  <TableCell>Manage</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {Array.isArray(rejectedProducts) && rejectedProducts?.map((product) => (          
                <TableRow key={product?.id} className="capitalize">
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <div className="lheight13">
                      <p className="">{product?.name} </p>
                    </div>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <div className="lheight13">
                      <p className="">{product?.product_type} </p>
                    </div>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}> 
                  <p className=""> &#x20A6;{addCommasToNumberString(product?.cost_price)}  </p>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}> <p className=""> &#x20A6;{addCommasToNumberString(product?.selling_price)} </p> </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    <div className="lheight13">
                      <p className="">{product?.reason} </p>
                    </div>
                  </TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}> <p className=""> {moment(product?.created_at).add(1, "years").calendar()} </p></TableCell>
                  <TableCell onClick={() => navigate(`/app/products/details/${product?.id}`)}>
                    {" "}
                    {/* 0 = Pending/No Action    1 = Accept/Publish   2 = Decline/Reject    3 = Send For Approval */}
                    {product?.status === '0' ?
                    <span className="badge warning c-chalk">Pending</span>
                    : product?.status === '1' ? <span className="badge success c-chalk">Published</span> :
                    product?.status === '2' ? <span className="badge error c-chalk">Rejected</span> :
                    <span className="badge warning c-chalk">Awaiting  Approval</span>
                    }
                  </TableCell>
                  <TableCell  
                  onClick={() => {
                    console.log(product);
                                    setSelectedProduct(product); 
                                    setIsEditMode(true);
                                    setNewProductModal(true);
                                  }}
>
                    {" "}
                    <EditIcon />{" "}
                  </TableCell>
                  <TableCell>
                  <select
                      name="update__order"
                      className="last-name form-control"
                      value={productLiveState}
                      onChange={(e) => handleProductLiveStatus(product, e)}
                      style={{marginTop: 18, textTransform: 'capitalize', width: '60%', height: 37,
                      padding: 10}}>
                    <option value="">Manage Order</option>
                    {user.accountType === "Admin" && (
                      <>
                       <option value="2">Reject</option>
                       <option value="1">Approve/Publish</option>
                       </>
                    )}
                    {user.accountType === "Vendor" && (
                      <option value="3">Send for Approval</option>
                    )}
                </select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TabPanel>

      {/* End Product Rejected List */}
      {/* {user.role !== 'Admin' && ( */}
        <>
      <TabPanel value={value} index={1}>
        <section className="flex-container alc p-y my-40">
          <div className="w-full">
            <button
              className="btn btn-primary p-25 pull-right"
              onClick={() => setNewCategoryModal(true)}>
              Add Category
            </button>
          </div>
        </section>
        {categories && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="Porduct Table">
            <TableHead>
              <TableRow>
                {categoryColumns.map((column) => (
                  <TableCell>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {categories && categories.map((category, index) => (                   
                <TableRow key={category.id} className="capitalize">
                {/* <TableCell className="b-r">
                  <div className="d-flex alc f-10 flex-start">
                      <img src={category.category_image} className="w50" alt={category?.name}/>
                  </div>
                </TableCell> */}
                <TableCell>
                    <h4 className="f-300">{category.name} </h4>
                </TableCell>
                
                <TableCell>{category.description}</TableCell>
                <TableCell>
                    <h4 className="f-300">{category.sub_categories.map((item) => item.name).join(', ')} </h4>
                </TableCell>
                {/* <TableCell> {moment(category.created_at).add(1, "years").calendar()} </TableCell> */}
                <TableCell onClick={()=>editCategory(category)}> 
                  {" "}
                  <EditIcon />{" "}
                </TableCell>
                <TableCell onClick={()=>deleteCategory(category.id)}>
                  {" "}
                  <DeleteIcon/>{" "}
                </TableCell>
              </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        )}
        {!categories && ( <p className="empty__record"> Seems you are new here... No Category has been added </p>) }
      </TabPanel>
      <TabPanel value={value} index={3}>
      <section className="flex-container alc p-y my-40">
          <div className="w-full">
            <button
              className="btn btn-primary p-25 pull-right"
              onClick={() => setNewBrandModal(true)}>
              Add Brand
            </button>
          </div>
        </section>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="Porduct Table">
            <TableHead>
              <TableRow>
                {brandColumns.map((column) => (
                  <TableCell>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {brands && brands.map((brand, index) => (                   
                <TableRow key={brand.id} className="capitalize">
                {/* <TableCell className="b-r">
                  <div className="d-flex alc f-10 flex-start">
                    <img src={brand.brand_image}  className="w50" alt={brand?.name}/>
                  </div>
                </TableCell> */}
                <TableCell>
                    <h4 className="f-300">{brand.name}</h4>
                </TableCell>
                <TableCell>{brand.description}</TableCell>
                {/* <TableCell> {moment(brand.created_at).add(1, "years").calendar()} </TableCell> */}
                <TableCell onClick={()=>editBrand(brand)}>
                  {" "}
                  <EditIcon />{" "}
                </TableCell>
                <TableCell onClick={()=>deleteBrand(brand.id)}>
                  {" "}
                  <DeleteIcon/>{" "}
                </TableCell>
              </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </TabPanel>
      </>
   
      <TabPanel value={value} index={2}>
        <section className="flex-container alc p-y my-40">
          <div className="w-full">
            <button
              className="btn btn-primary p-25 pull-right"
              onClick={() => setNewSubCategoryModal(true)}>
              Add Sub category
            </button>
          </div>
        </section>
        {subCategories && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="Product Table">
            <TableHead>
              <TableRow>
                {categoryColumns.map((column) => (
                  <TableCell>{column.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {subCategories && subCategories?.map((category, index) => (                   
                <TableRow key={category.id}>
                <TableCell className="b-r">
                  <div className="d-flex alc f-10 flex-start">
                      <img src={category.category_image}  className="w50" alt={category?.name}/>
                  </div>
                </TableCell>
                <TableCell>
                    <h4 className="f-300">{category.name} </h4>
                </TableCell>
                <TableCell>{category.description}</TableCell>
                {/* <TableCell> {moment(category.created_at).add(1, "years").calendar()} </TableCell> */}
                <TableCell onClick={()=>editSubCategory(category)}> 
                  {" "}
                  <EditIcon />{" "}
                </TableCell>
                <TableCell onClick={()=>deleteSubCategory(category.id)}>
                  {" "}
                  <DeleteIcon/>{" "}
                </TableCell>
              </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        )}
        {!subCategories && ( <p className="empty__record"> Seems you are new here... No Sub Categories has been added yet </p>) }
      </TabPanel>
      {/* Modal for vendors */}

      <Modal
        open={newProductModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Add Product</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-250">
              <div className="">
                {inputValues.image || selectedProduct?.image ?
                 <img src={inputValues.image || selectedProduct?.image} className="w-100i" name="image" alt="Product" value={inputValues.image || selectedProduct?.image || ""} /> :
                <img src={profile || selectedProduct?.image} className="w-100i" name="image" value={inputValues.image || selectedProduct?.image || ""}  alt="User Profile"/>
                }
                <div className="pos-rel w100-m10 ">
                  <input
  type="file"
  className="form-control-input no-border"
  name="file"
  accept=".jpg,.png,.jpeg"
  onChange={async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Step 1: Resize
      const resizedBlob = await resizeImage(file, 800, 800);

      // Step 2: Compress
      const compressedBlob = await compressImage(resizedBlob, 0.7);

      // Step 3: Convert to File to send
      const finalFile = new File([compressedBlob], file.name, {
        type: "image/jpeg",
      });

      // Step 4: Prepare FormData
      const formData = new FormData();
      formData.append("file", finalFile);

      // Optional: Show preview before upload
      const previewUrl = URL.createObjectURL(finalFile);
      setState((prev) => ({ ...prev, preview: previewUrl }));

      // Step 5: Upload
      const res = await fetch(`${BASE_URL}/products/upload-file`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      });

      const data = await res.json();

      setState((prev) => ({ ...prev, image: data.url }));
      console.log("Uploaded image URL:", data.url);
    } catch (err) {
      console.error("Upload error:", err);
    }
  }}
/>

                </div>
              </div>
            </div>
            <form style={{ width: "100%" }}>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Product Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g Herbal jinger"
                    onChange={onChangeHandler}
                    value={selectedProduct?.name || inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Type</label>
                  <select
                    className="search__bar w-100"
                    name="product_type"
                    value={selectedProduct?.product_type || inputValues.product_type || ""}
                    onChange={onChangeHandler}
                    >
                    <option value="default"> Select Product Type</option>
                      <option value="single">Single Product</option>
                      <option value="combo">Combo Product</option>
                  </select>
                </div>
                </section>
                <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Category</label>
                  <select
                    className="search__bar w-100"
                    value={selectedProduct?.category_id || inputValues.category_id || ""}
                    name="category_id"
                    onChange={handleCategoryChange}
                    >
                    <option value="default"> Select Category</option>
                    {categories?.map((category) => (
                      <option value={category.id}>{category.name}</option>
                    ))}
                  </select>
                </div>
              <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Sub Category</label>
                  <select
                    className="search__bar w-100"
                    value={inputValues.sub_category_id || ""}
                    name="sub_category_id"
                    onChange={onChangeHandler}
                    // value={inputValues.sub_categories}
                    disabled={!selectedCategory}
                    >
                    <option value="default"> Select Sub Category</option>
                    {subCategories?.map((sub_cat) => (
                      <option value={sub_cat.id}>{sub_cat.name}</option>
                    ))}
                  </select>
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Brand</label>
                  <select
                    className="search__bar w-100"
                    name="brand_id"
                    value={selectedProduct?.brand_id || inputValues.brand_id || ""}
                    onChange={onChangeHandler}
                    >
                    <option value="default"> Select Brand</option>
                    {brands?.map((brand) => (
                      <option value={brand.id}>{brand.name}</option>
                    ))}
                  </select>
                </div>
              </section>

              <section className="flex-container mb-lg">
                

                <div className="pos-rel w100-m10 ">
                  <label> Cost Price</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="cost_price"
                    placeholder="1500"
                    onChange={onChangeHandler}
                    value={selectedProduct?.cost_price || inputValues.cost_price || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label>Selling Price (lower than cost price)</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="selling_price"
                    placeholder="1200"
                    onChange={onChangeHandler}
                    value={selectedProduct?.selling_price || inputValues.selling_price || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label> Combo Price (lower than Selling price)</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="combo_price"
                    placeholder="800"
                    onChange={onChangeHandler}
                    value={selectedProduct?.combo_price || inputValues.combo_price || ""}
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
              <div className="pos-rel w100-m10 ">
                  <label> Product Available for Purchase?</label>
                  <select
                  className="form-control-input "
                  name="inStock"
                    // value={inputValues.category_id || ""}
                    // name="category_id"
                    onChange={onChangeHandler}
                    value={selectedProduct?.inStock || inputValues.inStock || ""}
                    >
                    <option value="default"> Select Product availability</option>
                    
                      <option value={1}>In Stock</option>
                      <option value={0}>Currently Out of Stock</option>
                  </select>

                  {/* <input
                    type="number"
                    className="form-control-input "
                    name="inStock"
                    placeholder="500"
                    onChange={onChangeHandler}
                    value={inputValues.inStock || ""}
                  /> */}
                </div>

                <div className="pos-rel w100-m10 ">
                  <label>Quantity AAvailable</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="quantity"
                    placeholder="500"
                    onChange={onChangeHandler}
                    value={selectedProduct?.quantity || inputValues.quantity || ""}
                  />
                </div>
              </section>
              <div className="pos-rel w100-m10 ">
                  <label>Weight</label>
                  <input
                      type="number"
                      className="form-control-input h-100"
                      name="weight"
                      placeholder="weight in kg"
                      onChange={onChangeHandler}
                      value={selectedProduct?.weight || inputValues.weight || ""}
                    />
                  </div>
                  Active Health Juice Is A Refreshing Wellness Drink Formulated To Support Daily Nutrition, Energy, And Overall Wellbeing. Made From Carefully Selected Natural Ingredients, It Complements A Healthy Lifestyle And Active Routine. Active Health Juice Is A Nutrient-Rich Wellness Beverage Designed For Individuals Who Want Convenient Daily Support For Energy, Vitality, And General Wellness. It Combines Plant-Based Extracts And Natural Nutrients To Help The Body Stay Balanced And Refreshed Throughout The Day. This Juice Is Ideal For People Managing Busy Schedules, Physical Activity, Or Wellness Goals, Offering A Simple Way To Nourish The Body While Staying Hydrated. Key Features & Benefits ✔ Supports Daily Vitality And Energy ✔ Helps Maintain Overall Body Wellness ✔ Provides Nutritional And Antioxidant Support ✔ Refreshing And Easy-To-Consume Liquid Format ✔ Suitable For Men And Women ✔ Can Be Taken Daily As Part Of A Healthy Routine Why Choose Active Health Juice? Active Health Juice Is Developed To Fit Modern Lifestyles Where Nutrition And Convenience Matter. Its Liquid Form Allows For Easy Absorption And Quick Intake, Making It A Practical Choice For Individuals Focused On Long-Term Wellness And Balanced Living. How To Use Shake Well Before Use. Consume As Recommended By The Manufacturer Or A Qualified Healthcare Professional. Best Used Consistently Alongside A Balanced Diet And Healthy Lifestyle. Product Specifications Product Type: Wellness / Nutritional Juice Form: Liquid Drink Category On PMall: Health & Wellness → Nutritional Drinks Target Audience: Adults (Men & Women) Safety & Disclaimer (PMall Compliance) This Product Is Not Intended To Diagnose, Treat, Cure, Or Prevent Any Disease. Pregnant Or Nursing Mothers And Individuals With Medical Conditions Should Consult A Healthcare Professional Before Use.
              <section className="flex-container mb-lg">
                <div className="pos-rel w-100 ">
                  <label style={{marginBottom: 7}}>Select Tags Associated with Product </label>
                  <Stack spacing={3} sx={{ width: "100%" }}>
                  <Autocomplete
            multiple
            freeSolo
            id="tags-outlined"
            options={[]}
            value={Array.isArray(selectedProduct?.tags) 
              ? selectedProduct.tags 
              : Array.isArray(inputValues?.tags) 
              ? inputValues.tags 
              : []}
            onChange={handleChange}
            filterSelectedOptions
            renderTags={(value, getTagProps) =>
              value?.map((option, index) => (
                <Chip
                  key={index}
                  variant="outlined"
                  label={option}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Type a tag and press enter" />
            )}
          />
                  </Stack>
                </div>
              </section>
              
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label>More Images 1</label>
                  <input
  type="file"
  className="form-control-input no-border"
  name="more_images"
  accept=".jpg,.png,.jpeg"
  multiple
  onChange={async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    try {
      setLoading(true);

      const uploadedUrls = [];

      for (let file of files) {
        // Step 1: Resize
        const resizedBlob = await resizeImage(file, 800, 800);

        // Step 2: Compress
        const compressedBlob = await compressImage(resizedBlob, 0.7);

        // Step 3: Convert to File
        const finalFile = new File([compressedBlob], file.name, {
          type: "image/jpeg",
        });

        // Step 4: Optional preview (if needed)
        // const previewUrl = URL.createObjectURL(finalFile);
        // You could store previews in state if you want to show before upload
        // setMoreImagesPreviews((prev) => [...prev, previewUrl]);

        // Step 5: Prepare FormData
        const formData = new FormData();
        formData.append("file", finalFile);

        // Step 6: Upload
        const res = await fetch(`${BASE_URL}/products/upload-file`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("authToken"),
          },
        });

        const data = await res.json();
        uploadedUrls.push(data.url);
      }

      // Step 7: Update state with all uploaded URLs
      setMoreImages((prev) => [...prev, ...uploadedUrls]);
      console.log("Uploaded images:", uploadedUrls);
    } catch (err) {
      console.error("Upload error:", err);
    } finally {
      setLoading(false);
    }
  }}
/>

                </div>
                <div className="pos-rel w100-m10 ">
                  <label>More Images 2</label>
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="more_images"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setMoreImages([...moreImages, data.url])
                          console.log(moreImages)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                    multiple
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label>More Images 3</label>
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="more_images"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setMoreImages([...moreImages, data.url])
                          console.log(moreImages)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                    multiple
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
              <div>
                <p className="uppercase f-13">Best taken:</p>
                <div className="spec-list m-10">
                  {bestTaken.map((item, index) => (
                    <div className="spec f-13">
                      <label className="mb-7">{item.name} </label>
                      <div
                          className="flex all-center"
                      >
                     <label className="switch">
                        <input
                            type="checkbox"
                            checked={item.value}
                            onChange={() => handleBestTakenToggle(index)}
                        />
                        <span className="slider round"></span>
                    </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              </section>
              <section className="flex-container mb-lg">
              <div>
                <p className="uppercase f-13">Product not for:</p>
                <div className="spec-list flex m-10">
                  {notFor.map((item, index) => (
                    <div className="spec f-13">
                     <label className="mb-7">{item.name} </label>
                      <div
                          className="flex all-center"
                      >
                      <label className="switch">
                        <input
                            type="checkbox"
                            checked={item.value}
                            onChange={() => handleNotForToggle(index)}
                        />
                        <span className="slider round"></span>
                    </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              </section>

              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Describe this product (Weight, variant, size etc) </label>
                  <textarea
                    placeholder=""
                    className="form-textarea w-100 mt-10"
                    name="description"
                    onChange={onChangeHandler}
                    value={selectedProduct?.description || inputValues.description || ""}
                    ></textarea>
                </div>

                {/* <div className="pos-rel w100-m10"></div> */}
              </section>

              <div className="flex__normal pull-right mt-35">
                <button
                  onClick={handleModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                <button className="btn btn-primary p-25 pull-right"
                 onClick={ VendorCreateProduct}
                disabled={loading}
                >
                {loading ? <ButtonLoader /> : isEditMode ? "Update Product"  : "Save Product" }
                </button>
              </div>
            </form>
           
          </section>
        </Box>
      </Modal>
      
      <Modal
        open={editProductModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleEditProductModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Update Product</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
                <img src={profile} className="w-100i" name="image" value={inputValues.image|| ""} alt="Product" />
                <div className="pos-rel w100-m10 ">
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      // if (selectedName == "") {
                      //   setAlert("Please Select a file name");
                      //   return;
                      // }
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setState((inputValues) => ({
                            ...inputValues,
                            image: data.url, 
                          }))
                          console.log(inputValues)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                  />
                </div>
                {/* <button className="btn btn-primary p-25 mt-15" onClick={uploadFile}>
                  Upload Photo
                </button> */}
              </div>
            </div>
            <form style={{ width: "100%" }}>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Product Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g IPhone 14"
                    onChange={onChangeHandler}
                    value={inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Category</label>
                  <select
                    className="search__bar w-100"
                    value={inputValues.category_id || ""}
                    name="category_id"
                    onChange={onChangeHandler}
                    >
                    <option value="default"> Select Category</option>
                    {categories?.map((category) => (
                      <option value={category.id}>{category.name}</option>
                    ))}
                  </select>
                </div>
              <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Sub Category</label>

                  <select
                    className="search__bar w-100"
                    name="sub_category_id"
                    onChange={onChangeHandler}
                    value={inputValues.sub_categories}
                    >
                    <option value="default"> Select Sub Category</option>
                    {subCategories?.map((sub_cat) => (
                      <option value={sub_cat.id}>{sub_cat.name}</option>
                    ))}
                  </select>
                </div>
              </section>

              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Product Brand</label>
                  <select
                    className="search__bar w-100"
                    name="brand_id"
                    value={inputValues.brand_id || ""}
                    onChange={onChangeHandler}
                    >
                    <option value="default"> Select Brand</option>
                    {brands?.map((brand) => (
                      <option value={brand.id}>{brand.name}</option>
                    ))}
                  </select>
                </div>

                <div className="pos-rel w100-m10 ">
                  <label> Cost Price</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="cost_price"
                    placeholder="1,500"
                    onChange={onChangeHandler}
                    value={inputValues.cost_price || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label>Selling Price</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="selling_price"
                    placeholder="1,200"
                    onChange={onChangeHandler}
                    value={inputValues.selling_price || ""}
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
              <div className="pos-rel w100-m10 ">
                  <label> PRODUCT CURRENTLY AVAILABLE FOR PURCHASE?</label>
                  <select
                  className="form-control-input "
                  name="inStock"
                    // value={inputValues.category_id || ""}
                    // name="category_id"
                    onChange={onChangeHandler}
                    value={inputValues.inStock || ""}
                    >
                    <option value="default"> Select Product availability</option>
                    
                      <option value={1}>In Stock</option>
                      <option value={0}>Currently Out of Stock</option>
                  </select>

                  {/* <input
                    type="number"
                    className="form-control-input "
                    name="inStock"
                    placeholder="500"
                    onChange={onChangeHandler}
                    value={inputValues.inStock || ""}
                  /> */}
                </div>
              {/* <div className="pos-rel w100-m10 ">
                  <label> In stock</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="inStock"
                    placeholder="1,500"
                    onChange={onChangeHandler}
                    value={inputValues.inStock || ""}
                  />
                </div> */}

                <div className="pos-rel w100-m10 ">
                  <label>Quantity</label>
                  <input
                    type="number"
                    className="form-control-input "
                    name="quantity"
                    placeholder="1,500"
                    onChange={onChangeHandler}
                    value={inputValues.quantity || ""}
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label style={{marginBottom: 7}}>Add Tags</label>
                  <Stack spacing={3} sx={{ width: "100%" }}>
                    <Autocomplete
                      multiple
                      id="tags-outlined"
                      options={top100Films}
                      name="tags"
                      onChange={handleChange}
                     // value={inputValues.tags || ""}
                      getOptionLabel={(option) => option.title}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select multiple" />
                      )}
                    />
                  </Stack>
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label>More Images</label>
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="more_images"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setState((inputValues) => ({
                            ...inputValues,
                            more_images: data.url, 
                          }))
                          console.log(inputValues)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                    multiple
                  />
                </div>
              </section>
              <section className="flex-container mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-10 "> Describe this product (Weight, variant, size etc) </label>
                  <textarea
                    className="form-textarea w-100 mt-10"
                    name="description"
                    onChange={onChangeHandler}
                    value={inputValues.description || ""}
                    ></textarea>
                </div>

                {/* <div className="pos-rel w100-m10"></div> */}
              </section>

              <div className="flex__normal pull-right mt-35">
                <button
                  onClick={handleEditProductModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                <button className="btn btn-primary p-25 pull-right" onClick={vendorUpdateProduct} disabled={loading} style={{marginBottom: 90}}
                >
                {loading ?<ButtonLoader /> : " Save Product"}
                </button>
              </div>
            </form>
          </section>
        </Box>
      </Modal>

      <Modal
        open={newCategoryModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleCategoryModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Add Category</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
                <img src={profile} className="profile_pic" name="image" value={inputValues.image|| ""} alt="Category" />
                <div className="pos-rel w100-m10 ">
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      // if (selectedName == "") {
                      //   setAlert("Please Select a file name");
                      //   return;
                      // }
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setState((inputValues) => ({
                            ...inputValues,
                            category_image: data.url, 
                          }))
                          console.log(inputValues)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                  />
                </div>
                {/* <button className="btn btn-primary p-25 mt-15" onClick={uploadFile}>
                  Upload Photo
                </button> */}
              </div>
            </div>
            <section className="flex-container flex-col g-20 mb-lg w-full">
              <form className="flex-container flex-col g-20 mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Category Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g IPhone 14"
                    onChange={onChangeHandler}
                    value={inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7">Category description</label>
                  <textarea
                    className="search__bar w-100"
                    value={inputValues.description|| ""}
                    name="description"
                    rows={6}
                    onChange={onChangeHandler}
                    >
                  </textarea>
                </div>
                <div className="flex__normal w-full pull-right mt-35">
                  <button
                    onClick={handleCategoryModalClose}
                    className="btn btn-secondary p-25 pull-right mr-10">
                    Cancel
                  </button>
                    <button className="btn btn-primary p-25 pull-right" onClick={addCategory} disabled={loading}
                  >
                    {loading ?<ButtonLoader /> : " Create Category"}
                  </button>
                </div>
              </form>
            </section>
          </section>
        </Box>
      </Modal>


{/* Reject Product Modal Reason */}

<Modal
        open={newRejectedProductModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleRejectedProductModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Rejected: Query Product</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
              </div>
            </div>
            <section className="flex-container flex-col g-20 mb-lg w-full">
              <form className="flex-container flex-col g-20 mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7">Reason Why Product Was Rejected</label>
                  <textarea
                    className="search__bar w-100"
                    name="rejectedReason"
                  onChange={onChangeHandlerForReason}
                  value={formData.rejectedReason}
                    rows={6}
                    >
                  </textarea>
                </div>
                <div className="flex__normal w-full pull-right mt-35">
                  <button
                    onClick={handleRejectedProductModalClose}
                    className="btn btn-secondary p-25 pull-right mr-10">
                    Cancel
                  </button>
                    <button className="btn btn-primary p-25 pull-right" onClick={addReasonForProductReject} disabled={loading}
                  >
                    {loading ?<ButtonLoader /> : "Submit Comment"}
                  </button>
                </div>
              </form>
            </section>
          </section>
        </Box>
      </Modal>

{/* End Reject Product Modal Reason */}


      <Modal
        open={editCategoryModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleEditCategoryModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Update Category</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
                <img src={inputValues.category_image} className="profile_pic" name="image" value={inputValues.image|| ""} alt="Category" />
                <div className="pos-rel w100-m10 ">
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      // if (selectedName == "") {
                      //   setAlert("Please Select a file name");
                      //   return;
                      // }
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setState((inputValues) => ({
                            ...inputValues,
                            category_image: data.url, 
                          }))
                          console.log(inputValues)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                  />
                </div>
              </div>
            </div>
            <section className="flex-container flex-col g-20 mb-lg w-full">
              <form className="flex-container flex-col g-20 mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Category Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g IPhone 14"
                    onChange={onChangeHandler}
                    value={inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7">Category description</label>
                  <textarea
                    className="search__bar w-100"
                    value={inputValues.description|| ""}
                    name="description"
                    rows={6}
                    onChange={onChangeHandler}
                    >
                  </textarea>
                </div>
                <div className="flex__normal w-30 pull-right mt-35">
                <button
                  onClick={handleEditCategoryModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                  <button className="btn btn-primary p-25 pull-right" onClick={vendorUpdateCategory} disabled={loading}
                >
                {loading ?<ButtonLoader /> : "Update"}
                  </button>
                </div>
              </form>
            </section>
          </section>
        </Box>
      </Modal>

      <Modal
        open={newSubCategoryModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleSubCategoryModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Add Sub Category</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
                <img src={profile} className="profile_pic" name="image" value={inputValues.image|| ""} alt="Sub Category" />
                <div className="pos-rel w100-m10 ">
                  
                </div>
                {/* <button className="btn btn-primary p-25 mt-15" onClick={uploadFile}>
                  Upload Photo
                </button> */}
              </div>
            </div>
            <section className="flex-container flex-col g-20 mb-lg w-full">
              <form className="flex-container flex-col g-20 mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Sub Category Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g IPhone 14"
                    onChange={onChangeHandler}
                    value={inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7">Sub Category description</label>
                  <textarea
                    className="search__bar w-100"
                    value={inputValues.description|| ""}
                    name="description"
                    rows={6}
                    onChange={onChangeHandler}
                    >
                  </textarea>
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7"> Parent Category</label>
                  <select
                    className="search__bar w-100"
                    value={inputValues.category_id || ""}
                    name="category_id"
                    onChange={onChangeHandler}
                    >
                    <option value="default"> Select Category</option>
                    {categories?.map((category) => (
                      <option value={category.id}>{category.name}</option>
                    ))}
                  </select>
                </div>
                <div className="flex__normal w-full pull-right mt-35">
                <button
                  onClick={handleSubCategoryModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                  <button className="btn btn-primary p-25 pull-right" onClick={addSubCategory} disabled={loading}
                >
                {loading ?<ButtonLoader /> : " Update Sub Category"}
                  </button>
                </div>
              </form>
            </section>
          </section>
        </Box>
      </Modal>

      <Modal
        open={newBrandModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleBrandModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Add Brand</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
                <img src={profile} className="w-100i" name="image" value={inputValues.image|| ""} alt="Brand"/>
                <div className="pos-rel w100-m10 ">
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      // if (selectedName == "") {
                      //   setAlert("Please Select a file name");
                      //   return;
                      // }
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setState((inputValues) => ({
                            ...inputValues,
                            brand_image: data.url, 
                          }))
                          console.log(inputValues)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                  />
                </div>
                {/* <button className="btn btn-primary p-25 mt-15" onClick={uploadFile}>
                  Upload Photo
                </button> */}
              </div>
            </div>
            <section className="flex-container flex-col g-20 mb-lg w-full">
              <form className="flex-container flex-col g-20 mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Brand Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g IPhone 14"
                    onChange={onChangeHandler}
                    value={inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7">Brand description</label>
                  <textarea
                    className="search__bar w-100"
                    value={inputValues.description|| ""}
                    name="description"
                    rows={6}
                    onChange={onChangeHandler}
                    >
                  </textarea>
                </div>
                <div className="flex__normal w-30 pull-right mt-35">
                <button
                  onClick={handleBrandModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                  <button className="btn btn-primary p-25 pull-right" onClick={addBrand} disabled={loading}
                >
                {loading ?<ButtonLoader /> : "Create Brand"}
                  </button>
                </div>
              </form>
            </section>
          </section>
        </Box>
      </Modal>

      <Modal
        open={editBrandModal}
        onClose={(reason) => {
          if (reason === 'backdropClick') return;
          handleEditBrandModalClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <div className="mb-35">
            <Typography id="modal-modal-title">
              <h4 className="summary__title t-xl title-case">Update Brand</h4>
            </Typography>
            <div className="s-divider"></div>
          </div>
          <section className="flex__normal">
            <div className="w-200">
              <div className="">
                <img src={inputValues?.brand_image} className="w-100i" name="image" value={inputValues.image|| ""} alt="Brand" />
                <div className="pos-rel w100-m10 ">
                  <input
                    type="file"
                    className="form-control-input no-border"
                    name="file"
                    accept=".jpg,.png,.jpeg"
                    onChange={(e) => {
                      // if (selectedName == "") {
                      //   setAlert("Please Select a file name");
                      //   return;
                      // }
                      const formData = new FormData();
                      const files = e.target.files;
                      files?.length && formData.append("file", files[0]);
                      //setLoading(true);
                      fetch(
                        `${BASE_URL}/products/upload-file`,
                        {
                          method: "POST",
                          body: formData,
                          headers: {
                            Authorization: "Bearer " + localStorage.getItem("authToken"),
                          },
                        }
                      )
                        .then((res) => res.json())
                        .then((data) => {
                          //setLoading(false);
                          console.log(data)
                          setState((inputValues) => ({
                            ...inputValues,
                            brand_image: data.url, 
                          }))
                          console.log(inputValues)
                        })
                        .catch((error) => {
                          //setLoading(false);
                          console.log(error)
                        });
                    }}
                  />
                </div>
                {/* <button className="btn btn-primary p-25 mt-15" onClick={uploadFile}>
                  Upload Photo
                </button> */}
              </div>
            </div>
            <section className="flex-container flex-col g-20 mb-lg w-full">
              <form className="flex-container flex-col g-20 mb-lg">
                <div className="pos-rel w100-m10 ">
                  <label> Brand Name</label>
                  <input
                    type="text"
                    className="form-control-input "
                    name="name"
                    placeholder="e.g IPhone 14"
                    onChange={onChangeHandler}
                    value={inputValues.name || ""}
                  />
                </div>
                <div className="pos-rel w100-m10 ">
                  <label className="mb-7">Brand description</label>
                  <textarea
                    className="search__bar w-100"
                    value={inputValues.description|| ""}
                    name="description"
                    rows={6}
                    onChange={onChangeHandler}
                    >
                  </textarea>
                </div>
                <div className="flex__normal w-30 pull-right mt-35">
                <button
                  onClick={handleEditBrandModalClose}
                  className="btn btn-secondary p-25 pull-right mr-10">
                  Cancel
                </button>
                  <button className="btn btn-primary p-25 pull-right" onClick={vendorUpdateBrand}  disabled={loading}
                >
                {loading ?<ButtonLoader /> : "Create"}
                  </button>
                </div>
              </form>
            </section>
          </section>
        </Box>
      </Modal>
    </section>
  );
};

export default ProductList;